import { Action } from "../actions";
import { ActionTypes } from "../constants";

export interface AuthnzState {
  forgotPassword: {
    formSubmitSuccess: boolean;
  };
}

const DEFAULT_AUTHNZ_STATE: AuthnzState = {
  forgotPassword: {
    formSubmitSuccess: false,
  },
};

export function authnzReducer(state: AuthnzState = DEFAULT_AUTHNZ_STATE, action: Action): AuthnzState {
  if (action.type === ActionTypes.AUTHNZ_FORGOT_PASSWORD_RESET) {
    return {
      ...state,
      forgotPassword: {
        formSubmitSuccess: true,
      },
    };
  } else {
    return state;
  }
}
